import { render, staticRenderFns } from "./CadastroContratoOperadora.vue?vue&type=template&id=22382158&"
import script from "./CadastroContratoOperadora.vue?vue&type=script&lang=js&"
export * from "./CadastroContratoOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports